import { Link } from 'react-router-dom'
import { PercentageValue } from '../components/ui/PercentageValue'
import { useLocale } from '../i18n/locale'

export function NotFoundPage() {
  const { t } = useLocale()
  return (
    <div className="page-container not-found-page">
      <section className="not-found-terminal" aria-labelledby="not-found-title">
        <div className="not-found-topline">
          <span>{t('notFound.publicUnmatched')}</span>
          <span>{t('notFound.page404')}</span>
        </div>
        <div className="not-found-signal">
          <PercentageValue value={0} element="strong" className="not-found-code" />
          <span>{t('notFound.unobserved')}</span>
        </div>
        <p className="eyebrow">{t('notFound.eyebrow')}</p>
        <h1 id="not-found-title">{t('notFound.title')}</h1>
        <p>{t('notFound.body')}</p>
        <Link className="button button-primary" to="/">{t('notFound.back')} <span aria-hidden="true">↗</span></Link>
      </section>
    </div>
  )
}
